<template>
  <div class="articles-page">
    <!-- Banner区域 -->
    <div class="banner">
      <div class="banner-content">
        <h1 class="title">美文赏析</h1>
        <p class="subtitle">品味人生，感悟生活</p>
        <div class="search-container">
          <div class="search-box">
            <el-input
              v-model="searchText"
              placeholder="搜索文章"
              class="search-input"
              :prefix-icon="Search"
            >
              <template #append>
                <el-button type="primary">搜索</el-button>
              </template>
            </el-input>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="container">
      <!-- 分类标签 -->
      <div class="category-section">
        <el-tabs v-model="activeCategory" class="category-tabs">
          <el-tab-pane label="全部" name="all" />
          <el-tab-pane label="散文" name="prose" />
          <el-tab-pane label="诗歌" name="poetry" />
          <el-tab-pane label="随笔" name="essay" />
          <el-tab-pane label="小说" name="novel" />
        </el-tabs>
      </div>

      <!-- 文章列表 -->
      <div class="articles-list">
        <el-row :gutter="30">
          <el-col :xs="24" :sm="12" :md="8" v-for="article in articles" :key="article.id">
            <div class="article-card" @click="showArticleDetail(article)">
              <div class="article-cover">
                <el-image :src="article.cover" fit="cover" />
                <div class="article-category">{{ article.category }}</div>
              </div>
              <div class="article-content">
                <h3 class="article-title">{{ article.title }}</h3>
                <p class="article-excerpt">{{ article.excerpt }}</p>
                <div class="article-meta">
                  <span class="author">
                    <el-avatar :size="20" :src="article.authorAvatar" />
                    {{ article.author }}
                  </span>
                  <span class="date">{{ article.date }}</span>
                </div>
                <div class="article-stats">
                  <span><i class="el-icon-view"></i> {{ article.views }}</span>
                  <span><i class="el-icon-star-off"></i> {{ article.likes }}</span>
                  <span><i class="el-icon-chat-dot-round"></i> {{ article.comments }}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 加载更多 -->
      <div class="load-more">
        <el-button type="primary" plain>加载更多</el-button>
      </div>
    </div>

    <!-- 文章详情对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="currentArticle?.title"
      width="70%"
      destroy-on-close
    >
      <div class="article-detail" v-if="currentArticle">
        <div class="article-header">
          <div class="author-info">
            <el-avatar :size="40" :src="currentArticle.authorAvatar" />
            <div class="author-meta">
              <div class="author-name">{{ currentArticle.author }}</div>
              <div class="publish-date">{{ currentArticle.date }}</div>
            </div>
          </div>
        </div>
        <div class="article-body" v-html="currentArticle.content"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref } from 'vue'
import { Search } from '@element-plus/icons-vue'

export default {
  name: 'Articles',
  setup() {
    const searchText = ref('')
    const activeCategory = ref('all')
    const dialogVisible = ref(false)
    const currentArticle = ref(null)

    // 模拟文章数据
    const articles = ref([
      {
        id: 1,
        title: '春日遐想',
        excerpt: '春天来了，万物复苏，树木抽出新芽，花儿竞相开放...',
        cover: 'https://via.placeholder.com/300x200',
        category: '散文',
        author: '张三',
        authorAvatar: 'https://via.placeholder.com/40',
        date: '2024-03-18',
        views: 1234,
        likes: 88,
        comments: 32,
        content: '<p>这是文章的详细内容...</p>'
      },
      // ... 更多文章数据
    ])

    const showArticleDetail = (article) => {
      currentArticle.value = article
      dialogVisible.value = true
    }

    return {
      searchText,
      activeCategory,
      articles,
      dialogVisible,
      currentArticle,
      showArticleDetail,
      Search
    }
  }
}
</script>

<style scoped>
.banner {
  height: 300px;
  background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -60px;
}

.banner-content {
  text-align: center;
  color: white;
  padding-top: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.category-section {
  margin-bottom: 30px;
}

.article-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  margin-bottom: 30px;
  cursor: pointer;
  transition: transform 0.3s;
}

.article-card:hover {
  transform: translateY(-5px);
}

.article-cover {
  position: relative;
  height: 200px;
}

.article-cover .el-image {
  width: 100%;
  height: 100%;
}

.article-category {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0,0,0,0.6);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.article-content {
  padding: 20px;
}

.article-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
}

.article-excerpt {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  color: #999;
  font-size: 14px;
}

.author {
  display: flex;
  align-items: center;
  gap: 8px;
}

.article-stats {
  display: flex;
  gap: 15px;
  color: #999;
  font-size: 13px;
}

.load-more {
  text-align: center;
  margin-top: 40px;
}

.article-detail {
  padding: 20px;
}

.article-header {
  margin-bottom: 30px;
}

.author-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.author-meta {
  display: flex;
  flex-direction: column;
}

.author-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.publish-date {
  font-size: 14px;
  color: #999;
}

.article-body {
  line-height: 1.8;
  color: #333;
}

@media (max-width: 768px) {
  .banner {
    height: 300px;
  }

  .article-card {
    margin-bottom: 20px;
  }
}
</style>
